import { useCallback, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserCurrentCompany } from 'modules/loggedUserInfo/selectors';
import {
  fetchCompanyBranchesRequest,
  setEmployeesFilters,
} from 'modules/SalaryModule/Employees/actions';
import { selectLastSyncingStatus } from 'modules/SalaryModule/Employees/selectors';
import { getAbsencesTypesRequest } from 'modules/SalaryModule/Calendar/actions';

import { fetchSchedulesRequest } from 'modules/SalaryModule/CompanySettings/actions';
import { AddVacationModal } from 'containers/Salary/EmployeesPage/AddVacationModal';
import { toggleVacationModalVisibility } from 'modules/SalaryModule/Vacations/actions';
import { EMPLOYEE_HEADER } from 'const/translations/SalaryEmployeePage';

const { IS_SILAE_SYNCING } = EMPLOYEE_HEADER;

const propTypes = {
  children: PropTypes.any,
};

const SalaryContainer = ({ children }) => {
  const dispatch = useDispatch();
  const {
    id: companyId,
    managedSilae,
    payEnabled,
  } = useSelector(selectUserCurrentCompany);
  const lastSyncingStatus = useSelector(selectLastSyncingStatus);

  useEffect(() => {
    dispatch(fetchSchedulesRequest(companyId));
    dispatch(fetchCompanyBranchesRequest(companyId));
    dispatch(getAbsencesTypesRequest());
    dispatch(
      setEmployeesFilters({
        establishments: '',
        natureEmployments: '',
        classifications: '',
        contracts: '',
      })
    );
  }, [dispatch, companyId, managedSilae, payEnabled]);

  useEffect(() => {
    if (lastSyncingStatus === 'in_process') {
      message.info(IS_SILAE_SYNCING, 0);
    } else {
      message.destroy();
    }

    return () => {
      message.destroy();
    };
  }, [lastSyncingStatus]);

  const toggleModalVisibility = useCallback(() => {
    dispatch(toggleVacationModalVisibility());
  }, [dispatch]);

  return (
    <>
      <AddVacationModal onClose={toggleModalVisibility} />
      {children}
    </>
  );
};

SalaryContainer.propTypes = propTypes;

export default memo(SalaryContainer);
